import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { User, Shield, Building, Mail, Key } from 'lucide-react';

export const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-slate-100">User Profile</h2>
        <p className="text-xs text-slate-400">Manage account information and security settings</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="md:col-span-1 text-center">
          <div className="w-20 h-20 rounded-full bg-sky-500/20 text-sky-400 font-semibold text-2xl flex items-center justify-center mx-auto mb-4 border border-sky-500/30">
            {user.name.slice(0, 2).toUpperCase()}
          </div>
          <h3 className="font-semibold text-slate-100 text-lg">{user.name}</h3>
          <p className="text-xs text-slate-400 mb-3">{user.email}</p>
          <Badge label={user.role} variant="info" />
        </Card>

        <Card title="Account Specifications" className="md:col-span-2 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
            <div className="flex items-center gap-3 p-3 bg-slate-900/60 rounded-lg border border-slate-800">
              <User className="w-5 h-5 text-sky-400" />
              <div>
                <p className="text-[10px] text-slate-500 font-medium">User Identifier</p>
                <p className="font-mono text-xs text-slate-200">{user.user_id}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 bg-slate-900/60 rounded-lg border border-slate-800">
              <Shield className="w-5 h-5 text-emerald-400" />
              <div>
                <p className="text-[10px] text-slate-500 font-medium">Assigned Role</p>
                <p className="text-xs text-slate-200">{user.role}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 bg-slate-900/60 rounded-lg border border-slate-800">
              <Building className="w-5 h-5 text-amber-400" />
              <div>
                <p className="text-[10px] text-slate-500 font-medium">Department ID</p>
                <p className="text-xs text-slate-200">{user.department_id || 'Global'}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 bg-slate-900/60 rounded-lg border border-slate-800">
              <Mail className="w-5 h-5 text-purple-400" />
              <div>
                <p className="text-[10px] text-slate-500 font-medium">Email Status</p>
                <p className="text-xs text-emerald-400 font-medium">Verified Active</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
